<template>
    <div>
        <div class="painelCinza">
            <b-container fluid>
                <b-row>
                    <b-col align-self="start">
                        <h6>
                            <b>{{ $t("label.dados") }}</b>
                        </h6>
                    </b-col>
                </b-row>
                <br/>
                <b-row align-v="start">
                    <b-col align-self="start" fluid="lg" cols="3" class="tamanhoResponsivoCodigoCartao">
                        {{ $t('label.codigo_cartao') }}
                        <b-form-group class="input-label">
                            <b-form-input
                                v-model="dadosCartaoLocal.codExternoCartao"
                                readonly
                                type="text"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col align-self="start" fluid="lg" cols="2" class="tamanhoResponsivoDigito">
                        {{ $t('label.digito') }}
                        <b-form-group class="input-label">	
                            <b-form-input
                                v-model="dadosCartaoLocal.digitoVerificador"
                                readonly 
                                type="text"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col align-self="start" fluid="lg" cols="3" class="tamanhoResponsivoDataSaldo">
                        {{ $t('label.data_referencia_saldo') }}
                        <b-form-group  class="input-label">
                            <b-form-input
                                v-model="dataFormatada"
                                readonly
                                type="text"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col v-if="this.praca.toLowerCase() != 'pnv'" align-self="start" fluid="lg" cols="1" class="tamanhoResponsivoSaldo">
                        {{ $t('label.saldo_no_cartao') }}
                        <b-form-group class="input-label">
                            <b-form-input
                                v-model="valorSaldoFormatado"
                                readonly						  
                                type="text"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <br />
                <b-row>
                    <b-col fluid="lg" cols="8" class="tamanhoResponsivoNome">	
                        {{ $t('label.titular') }}				  
                        <b-form-group class="input-label">
                            <b-form-input
                                v-model="this.dadosCartaoLocal.titular.nomeTitular"
                                readonly
                                    type="text"
                            ></b-form-input>
                            </b-form-group>
                    </b-col>
                    <b-col align-self="center" fluid="lg" cols="2">
                        <b-button :disabled="this.disabledNovoPedido" id="btn-novo-pedido" @click="abreModalNovoPedido()" variant="success" size="sm">{{ $t('label.novo_pedido') }}</b-button>
                        <b-modal no-close-on-backdrop centered size="sm" ref="bv-modal-novo-pedido" id="bv-modal-novo-pedido" hide-footer  title="Valor da recarga">
                            <div class="d-block text-center">
                                <b-container fluid>
                                    <b-row v-if="this.permiteSelecionarPagto">
                                        <b-col>
                                            {{ $t('label.forma_de_pagamento') }}
                                            <b-form-group class="input-label">
                                                <b-form-select :disabled="bloquearSelecionarPagto" v-model="selectedFormaDePagamento" :options="listaFormaDePagamento" size="lg" class=""></b-form-select>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row v-if="this.porTarifa">
                                        <b-col>
                                            {{ $t('label.tarifa') }}
                                            <b-form-group class="input-label">
                                                <b-form-select v-model="selected" @change="atualizaValorRecarga" :options="options" size="lg" class=""></b-form-select>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row v-if="this.porTarifa">
                                        <b-col>
                                            {{ $t('label.quantidade') }}
                                            <b-form-group class="input-label">
                                                <b-input-group >
                                                    <b-form-input
                                                        class="no-spinners"
                                                        size="lg"
                                                        v-model="quantidade"
                                                        @input="removeZeroEsquerda"
                                                        @change="atualizaValorRecarga"
                                                        @keydown="preventDecimal"
                                                        @paste="sanitizePaste"
                                                        @focus="initializeValue"
                                                        type="number"
                                                        >
                                                    </b-form-input>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col>
                                            {{ $t('label.valor_recarga') }}
                                            {{ valorRecarga }}
                                            <b-form-group class="input-label">
                                                <b-input-group size="lg" prepend="R$">
                                                    <b-form-input
                                                        v-model="valorRecarga"
                                                        @change="atualizaValorRecarga"
                                                        :readonly="this.porTarifa"						  
                                                        type="number"
                                                    ></b-form-input>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="6">
                                            <b-button class="w-100" @click="acrescentaQuantidade" variant="success" size="md">{{ $t('label.mais') }}</b-button>
                                        </b-col>
                                        <b-col cols="6">
                                            <b-button class="w-100" @click="diminuiQuantidade" variant="danger" size="md">{{ $t('label.menos') }}</b-button>											
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-button :disabled="this.valorRecarga == null || this.valorRecarga === undefined || this.valorRecarga <= 0" class="mr-3 ml-3 mt-3 mb-2" block @click="$bvModal.show('bv-modal-certificacao')">{{ $t('label.ok') }}</b-button>
                                    </b-row>
                                </b-container>
                            </div>
                            <b-modal centered size="sm" id="bv-modal-certificacao" hide-footer  title="ATENÇÃO!">
                                <div class="d-block text-center">
                                    <b-container fluid>
                                        <b-row>
                                            <b-col>
                                                {{ $t('label.tem_certeza_que_deseja_recarregar') }}<b>{{ valorModalFormatado }}</b>{{ $t('label.no_cartao_com_codigo') }}<b>{{dadosCartaoLocal.codExternoCartao}}</b>{{ $t('label.interrogacao') }}
                                            </b-col>
                                        </b-row>
                                        <b-row>					
                                            <b-col>
                                                <b-button class="mt-3" variant="success" block @click="this.confirmaPedidoRecarga" :disabled="this.botaoDesabilitado">{{ botaoDesabilitado ? $t('label.processando') : $t('label.sim') }}</b-button>
                                                <b-button class="mt-3" variant="danger" block @click="$bvModal.hide('bv-modal-certificacao')">{{ $t('label.nao') }}</b-button>
                                            </b-col>
                                        </b-row>									
                                    </b-container>
                                </div>
                            </b-modal>
                        </b-modal>
                    </b-col>
                </b-row>
                <b-modal  centered size="md" id="modal-QRCode" hide-footer @hidden="refreshListaPedidos">
                    <div class="d-block text-center">
                        <b-container fluid>
                            <b-row>
                                <p class="pl-4"><strong>Número do Pedido: </strong>{{ this.pedidoQRCode }}</p>
                            </b-row>
                            <b-row>
                                <p class="pl-4"><strong>Valor: </strong>{{this.formataValorGrid(this.valorQRCode)}}</p>
                            </b-row>
                            <b-row>
                                <p class="pl-4 codigo-pix"><strong>Código Pix: </strong>{{this.emv}}</p>
                            </b-row>
                            <b-row class="pl-4">
                                <b-button v-clipboard:copy="this.emv">Copiar</b-button>
                            </b-row>
                            <img :src="`data:image/png;base64,${this.imgQRCode}`" />	
                            <b-row>
                                <p class="pl-4"><strong>ATENÇÃO: </strong>{{ $t('label.apos_pagamento_pix') }}</p>
                            </b-row>						
                        </b-container>
                    </div>
                </b-modal>
                <b-row>
                <b-col>
                    <div>
                        <b-button class="espacamentoBotoes" @click="abreModalDadosCadastrais" size="sm">{{ $t('label.dados_cadastrais') }}</b-button>
                    </div>
                </b-col>
                    <b-col fluid="lg" cols="2" v-if="dadosCartaoLocal.dependenteTitular != null || dadosCartaoLocal.dependenteTitular != undefined">
                        <b-modal size="lg" id="modal-dados-cadastrais" hide-footer centered title="Dados Cadastrais">
                            <div class="painelModal">
                                <template>
                                    <b-container fluid>
                                            <b-row align-v="start">
                                                    <b-col align-self="start">
                                                    {{ $t('label.tipo_de_logradouro') }}
                                                    <b-form-group class="input-label" id="numero">
                                                        <select v-model="dadosCartaoLocal.dependenteTitular.dependente.tipoLogradouro.id">
                                                            <option disabled value="">{{ $t('label.tipo_do_logradouro') }}</option>
                                                            <option v-for="item in listaLogradouroLocal" v-bind:key="item.codigo" :value="item.codigo"> {{ item.descricao }}</option>														
                                                        </select>
                                                    </b-form-group>		
                                                    </b-col>
                                                <b-col>
                                                    {{ $t('label.logradouro') }}
                                                    <b-form-group class="input-label" >
                                                            <b-form-input
                                                            v-model="dadosCartaoLocal.dependenteTitular.dependente.nomeLogradouro"
                                                                type="text"
                                                        ></b-form-input>
                                                    </b-form-group>		
                                                    </b-col>
                                                <b-col>
                                                    {{ $t('label.complemento') }}
                                                    <b-form-group class="input-label">
                                                        <b-form-input
                                                            v-model="dadosCartaoLocal.dependenteTitular.dependente.complemento"
                                                                type="text"
                                                        ></b-form-input>
                                                    </b-form-group>			
                                                    </b-col>
                                                <b-col>
                                                    {{ $t('label.no') }}
                                                    <b-form-group class="input-label">
                                                        <b-form-input
                                                            v-model="dadosCartaoLocal.dependenteTitular.dependente.numero"
                                                                type="text"
                                                            @keypress="this.metodosAuxiliares.isNumber($event)"
                                                        ></b-form-input>
                                                    </b-form-group>			
                                                    </b-col>			
                                            </b-row>
                                            <br>
                                            <b-row align-v="start">
                                                <b-col>
                                                    {{ $t('label.bairro') }}
                                                    <b-form-group class="input-label" >
                                                            <b-form-input
                                                                v-model="dadosCartaoLocal.dependenteTitular.dependente.bairro"
                                                                type="text"
                                                        ></b-form-input>
                                                    </b-form-group>		
                                                    </b-col>
                                                    <b-col>
                                                    {{ $t('label.municipio') }}
                                                    <b-form-group class="input-label">
                                                        <select v-model="dadosCartaoLocal.dependenteTitular.dependente.municipio.id">
                                                            <option disabled value="">{{ $t('label.municipio') }}</option>
                                                            <option v-for="item in listaMunicipioLocal" v-bind:key="item.codigo" :value="item.codigo"> {{ item.descricao }}</option>

                                                        </select>
                                                    </b-form-group>		
                                                    </b-col>  
                                                <b-col>
                                                    {{ $t('label.cep') }}
                                                    <b-form-group class="input-label">
                                                        <b-form-input
                                                            v-model="dadosCartaoLocal.dependenteTitular.dependente.cep"
                                                            v-mask="'#####-###'"
                                                            type="text"
                                                            @keypress="this.metodosAuxiliares.isNumber($event)"
                                                            :maxlength="cepMax"
                                                        ></b-form-input>
                                                    </b-form-group>			
                                                    </b-col>			
                                                <b-col>
                                                    {{ $t('label.telefone') }}
                                                    <b-form-group class="input-label">
                                                        <b-form-input
                                                            v-model="dadosCartaoLocal.dependenteTitular.dependente.telefone"
                                                            v-mask="'(##) #########'"
                                                            :maxlength="telefoneMax"
                                                                type="text"
                                                            @keypress="this.metodosAuxiliares.isNumber($event)"
                                                        ></b-form-input>
                                                    </b-form-group>			
                                                    </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col align-self="start" fluid="lg" cols="12">
                                                    {{ $t('label.email') }}
                                                    <b-form-group class="input-label">
                                                        <b-form-input
                                                            v-model="dadosCartaoLocal.dependenteTitular.dependente.email"
                                                            type="text"
                                                        ></b-form-input>
                                                    </b-form-group>			
                                                    </b-col>	
                                            </b-row>
                                    </b-container>
                                </template>
                            </div>
                            <b-button variant="success" class="mt-1" block @click="validaSalvar">{{ $t('botao.salvar') }}</b-button>
                            <b-button variant="danger" class="mt-1" block @click="$bvModal.hide('modal-dados-cadastrais')">{{ $t('botao.fechar') }}</b-button>
                        </b-modal>
                    </b-col>
                </b-row>
            </b-container>
            <br>
            <b-container fluid>
                <b-row>
                    <b-col b-col fluid="lg" cols="10" >
                        <div>
                            <div class="text-center">
                                <b-spinner variant="primary" v-if="spinnerQrcode" label="Text Centered"></b-spinner>
                            </div>
                            <div class="text-left mb-2">
                                <b-button size="sm" variant="info" @click="refreshListaPedidos()"><b-icon icon="arrow-repeat" font-scale="2"></b-icon></b-button>
                            </div>
                            <div v-if="dadosCartaoLocal.descricaoCurso != null" style="margin-left: 210px;">
                                {{ $t('label.estudante_do_curso') }}<b>{{dadosCartaoLocal.descricaoCurso}}</b>{{ $t('label.do_ano_letivo') }}<b>{{dadosCartaoLocal.anoLetivo}}</b>{{ $t('label.com_inicio_em') }}<b>{{dadosCartaoLocal.dataInicialCurso}}</b>{{ $t('label.ate') }}<b>{{dadosCartaoLocal.dataFinalCurso}}</b>
                            </div>
                            <template>
                                <div class="table-container">
                                    <b-table :id="my-table" ref="table" bordered hover :items="Object.assign([], this.listaPedidosLocal)" :fields="fields" :per-page="perPage" :current-page="currentPage">
                                    <template v-slot:cell(actions)="data">
                                        <b-button v-if="data.item.id.solicitacaoPedidoCarga.status == 'G' && data.item.id.solicitacaoPedidoCarga.formaPagamento.id != 14" size="sm" class="mr-2" variant="info" :disabled="spinnerBoleto" @click="imprimirBoleto(data.item.id.solicitacaoPedidoCarga.id.codPedidoSolicitacao)">
                                            <b-spinner v-if="spinnerBoleto" small></b-spinner>
                                            <span v-if="!spinnerBoleto">{{ $t('label.boleto') }}</span>
                                        </b-button>
                                        <b-button v-if="data.item.id.solicitacaoPedidoCarga.formaPagamento.id == 14 && (data.item.id.solicitacaoPedidoCarga.status != 'F' && data.item.id.solicitacaoPedidoCarga.status != 'P')" size="sm" class="mr-2" variant="info" @click="imprimirPix(data.item.txId, data.item.id.solicitacaoPedidoCarga.id.codPedidoSolicitacao, data.item.valorCobrado)">{{ $t('label.pix') }}</b-button>
                                        <b-button v-if="data.item.id.solicitacaoPedidoCarga.status == 'F' || data.item.id.solicitacaoPedidoCarga.status == 'P'" size="sm" class="mr-2" variant="warning" @click="imprimirRecibo(data.item.id.solicitacaoPedidoCarga.id.codPedidoSolicitacao)">{{ $t('label.recibo') }}</b-button>
                                    </template>
                                    </b-table>
                                </div>
                            </template>
                            <b-pagination
                                align="center"
                                v-model="currentPage"
                                :total-rows="this.rows"
                                :per-page="perPage"
                                aria-controls="my-table"
                            ></b-pagination>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
  </template>
  
  <script>
  import {praca} from '../config.js';
  
  import BaseMixin from "../mixins/BaseMixin";
  import CartaoService from "@/services/CartaoService";
  import EstudanteService from "@/services/estudante/EstudanteService";
  import PixService from "@/services/PixService";
  import LogradouroService from "@/services/endereco/LogradouroService";
  import MunicipioService from "@/services/endereco/MunicipioService";
  import DadosCadastraisModel from "@/models/DadosCadastraisModel";
  import DadosCadastraisValidator from "@/models/validator/DadosCadastraisValidator";
  import EstudanteValidator from "@/models/validator/EstudanteValidator";
  import MetodosAuxiliares from "@/helper/MetodosAuxiliares";
  import moment from 'moment';
  import {mapGetters, mapState, mapActions} from 'vuex';
  export default {
  
    mixins: [BaseMixin],
  
    data() {
            return {
                disabledNovoPedido: false,
                selected: 0,
                selectedFormaDePagamento: 0,
                quantidade: 1,
                options: [],
    
                imgQRCode: '',
                pedidoQRCode: '',
                valorQRCode: '',
                emv: 'teste',
    
                spinnerQrcode: false,
                spinnerBoleto: false,
    
                praca: praca,
                botaoDesabilitado: false, 
    
                cartaoService: new CartaoService(),
                estudanteService: new EstudanteService(),
                pixService: new PixService(),
                metodosAuxiliares: new MetodosAuxiliares(),
                dadosCadastraisValidator: new DadosCadastraisValidator(),
                estudanteValidator: new EstudanteValidator(),
                logradouroService: new LogradouroService(),
                municipioService: new MunicipioService(),
    
                porTarifa: true,
    
                permiteSelecionarPagto: false,
                bloquearSelecionarPagto: false,
    
                flowid: "",
                tenant: "",
                novoTxId: null,
                registrarNovoTXID: null,
                status: '',
                pixEndToEnd: [],

                   
                nomeTitular : "",
                cnpj : "",
                contaCorrente : "",
                agencia : "",

                imageError:'',
                imageLoaded:false,
                image:{
                    size:'',
                    height:'',
                    width:'',
                    base64: '',
                },
    
                dataCriacao: null,
                expiracaoPix: 0,
                tempoDecorridoSegundos: 0,

                documentosCadastrados: [],
                tipoEstatusDocumento: '',
    
                perPage: 5,
                currentPage: 1,
                valorRecarga: 0,
                valorRecargaLimit: 650,
                tipoConteudo: '',
                dadosCartaoLocal: {},
                listaLogradouroLocal: [],
                listaPedidosLocal: [],
                listaFormaDePagamento: [],
                listaMunicipioLocal: [],
                listaTipoDocumentoLocal: [],
                referenciaSaldo: '',
                dataPedido: '',
                cepMax: 9,
                telefoneMax: 14,


                fields: [
                    {
                        key: 'id.solicitacaoPedidoCarga.id.codPedidoSolicitacao',
                        label: 'Código do Pedido',		
                    },
                    {
                        key: 'id.solicitacaoPedidoCarga.dataPedido',
                        label: 'Data do pedido',
                        formatter: 'formatarDateTime',
                    },
                    {
                        key: 'valorCarga',
                        label: 'Valor solicitado',   
                        formatter: 'formataValorGrid',
                        
                    },
                    {
                        key: 'valorCobrado',
                        label: 'Valor cobrado',   
                        formatter: 'formataValorGrid',
                        
                    },
                    {
                        key: 'id.solicitacaoPedidoCarga.status',
                        formatter: 'formataSituacaoGrid',
                        label: 'Situação',		
                    },
                    {
                        key: 'actions',
                        label: 'Ação',		
                    },
                ],
            };
        },
  
        async created() {
            this.configBreadCrumb({
                botoesAcao: {
                    salvar: false,
                    voltar: true
                }
            });
  
            this.populaDadosCartaoLocal()
            this.verificaTipoLogradouro()

  
            if(this.dadosCartaoLocal.codExternoCartao == undefined) {
                this.$router.push({ name: "Home" });
            } else {
                await this.getListaPedidos(this.dadosCartaoLocal.codExternoCartao);
                await this.consultarMetodoCompra(this.dadosCartaoLocal.codExternoCartao);
                await this.populaFormasDePagamento(this.dadosCartaoLocal.codExternoCartao, this.praca);
                await this.getListaMunicipio();
                await this.getListaLogradouro();
                
                this.populaListaPedidosLocal();
                this.populaReferenciaSaldoLocal();
                this.populaDataPedido();
                this.populaListaMunicipioLocal();
                this.populaListaLogradouroLocal();
            }
        },
        computed: {
            copiaCola() {
                return this.emv
            },

            rows() {
                return Object.assign([], this.listaPedidosLocal).length
            },

            dataFormatada: function() {
                return this.formatarDateTime(this.dataPedido)
            },

            valorSaldoFormatado: function() {
                const saldo = this.dadosCartaoLocal && this.dadosCartaoLocal.saldo !== undefined ? this.dadosCartaoLocal.saldo : "0";
                return this.formataValorGrid(saldo);
            },

            valorModalFormatado: function() {
                return this.formataValorGrid(this.valorRecarga)
            },

            ...mapGetters('cartaoStore', ['Cartao']),
            ...mapState('cartaoStore', ['Cartao']),
            ...mapGetters('listaLogradouroStore', ['ListaLogradouro']),
            ...mapState('listaLogradouroStore', ['ListaLogradouro']),
            ...mapGetters('listaPedidosStore', ['ListaPedidos']),
            ...mapState('listaPedidosStore', ['ListaPedidos']),	
            ...mapGetters('listaMunicipioStore', ['ListaMunicipio']),
            ...mapState('listaMunicipioStore', ['ListaMunicipio']),	
        },

        watch: {
            quantidade(newValue) {
                if (isNaN(newValue)) {
                    this.quantidade = 0;
                }
                this.atualizaValorRecarga();
            },
        },

  
        methods: {
    
            ...mapActions('listaPedidosStore', ['updateStateListaPedidos']),
            ...mapActions('listaMunicipioStore', ['updateStateListaMunicipio']),
            ...mapActions('listaLogradouroStore', ['updateStateListaLogradouro']),
  
            voltar() {
              this.$router.push({ name: "Home" });
            },

            verificaTipoLogradouro() {

                if(!this.dadosCartaoLocal.dependenteTitular.dependente.tipoLogradouro) {
                    this.dadosCartaoLocal.dependenteTitular.dependente.tipoLogradouro = {}
                    this.dadosCartaoLocal.dependenteTitular.dependente.tipoLogradouro.id = ''
                }
            },

            populaDadosCartaoLocal() {
              this.dadosCartaoLocal = Object.assign({}, this.Cartao)
            },
  
            populaListaPedidosLocal() {
              this.listaPedidosLocal = Object.assign({}, this.ListaPedidos);
            },
  
            populaReferenciaSaldoLocal() {	
                if(this.ListaPedidos == null || this.ListaPedidos == undefined || this.ListaPedidos == ""){
                    this.referenciaSaldo = ''
                } else {
                    this.referenciaSaldo = Object.assign({}, this.ListaPedidos[0].id.solicitacaoPedidoCarga);	
                }
            },
  
            populaListaLogradouroLocal() {
                this.listaLogradouroLocal = Object.assign({}, this.ListaLogradouro);
            },
  
            populaListaMunicipioLocal() {
                this.listaMunicipioLocal = Object.assign({}, this.ListaMunicipio);	
            },
  
            populaDataPedido() {
                this.dataPedido = this.dadosCartaoLocal.dataUsoCartao
            },
  
            acrescentaQuantidade() {
                this.quantidade = parseInt(this.quantidade) + 1;
                if (!this.porTarifa) {
                    this.valorRecarga = parseFloat(this.valorRecarga) + parseFloat(this.selected);
                }
                this.atualizaValorRecarga();
            },
          
            diminuiQuantidade() {
                if (parseInt(this.quantidade) > 0) {
                    this.quantidade = parseInt(this.quantidade) - 1;
                    if (!this.porTarifa) {
                        this.valorRecarga = parseFloat(this.valorRecarga) - parseFloat(this.selected);
                    }
                }
                this.atualizaValorRecarga();
            },

            removeZeroEsquerda() {
                this.quantidade = this.quantidade.replace(/^0+(\d)/, '$1');
            },

            atualizaValorRecarga() {                
                if (typeof this.quantidade === 'string') {
                    this.quantidade = parseFloat(this.quantidade);
                    return                    
                }

                let valor = parseFloat(this.quantidade) * parseFloat(this.selected);

                if (this.valorRecarga > 650) {
                    this.quantidade = Math.ceil((650 / this.selected) - 0.5);
                    this.valorRecarga = parseFloat(this.quantidade) * parseFloat(this.selected);
                }

                if (this.porTarifa) {
                    
                valor = Math.max(valor, this.valorRecargaLimit);
                this.valorRecarga = (Math.round(valor * 100) / 100).toFixed(2);
                } else {
                    this.valorRecarga = (Math.round(this.valorRecarga * 100) / 100).toFixed(2);
                }
            },

  
            formataSituacaoGrid(value) {
                switch (value) {
                case 'F':
                    return 'Fechado'; break;
                case 'E':
                    return 'Estocado'; break;
                case 'P':
                    return 'Pago'; break;
                case 'C':
                    return 'Cancelado'; break;  
                case 'G':
                    return 'Guia'; break; 
                case 'A':
                    return 'Aberto'; break; 
                default:
                    return 'Tipo não definido'; break;
                }
            },

            preventDecimal(event) {
                const invalidChars = ['.', ',', '-', '+'];
                if (invalidChars.includes(event.key)) {
                    event.preventDefault();
                }
            },

            sanitizePaste(event) {
                event.preventDefault();
                const text = (event.clipboardData || window.clipboardData).getData('text');
                const sanitizedText = text.replace(/[.,]/g, '');
                if (!isNaN(sanitizedText.trim())) {
                    this.quantidade = parseInt(this.quantidade + sanitizedText, 10);
                }
            },

            retornaStatus(tipoConteudo) {
                const documento = this.tipoEstatusDocumento.find(documento => documento.id === tipoConteudo);
                if (!documento) return "";

                switch (documento.statusDocumento) {
                    case "A":
                        return "Aprovado";
                    case "P":
                        return "Em análise";
                    case "R":
                        return "Reprovado";
                    default:
                        return "Status Desconhecido"; 
                }
            },

            retornaTipoConteudo(value) {
                switch (value) {
                case  9:
                    return 'Foto 3x4'; break;
                case  10:
                    return 'CPF'; break;
                case  11:
                    return 'RG'; break;
                case  12:
                    return 'Comprovante de matrícula'; break;  
                case  13:
                    return 'Comprovante de cadastro'; break; 
                case  14:
                    return 'Carteira de estudante frente'; break;
                case  15:
                    return 'Carteira de estudante verso'; break;
                default:
                    return 'Selecione um tipo de documento'; break;
                }
            },
  
            formatarDateTime(date) {
                if (!date) {
                    return moment(new Date()).format('DD/MM/YYYY HH:mm:ss')
                } else {
                    return moment(date).format('DD/MM/YYYY HH:mm:ss')
                }
            },

  
            formataValorGrid(value) {
                let val = (value/1).toFixed(2).replace('.', ',')
                return 'R$ ' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            },
  
            async abreModalNovoPedido() {
                this.valorRecarga = 0;
                this.quantidade = 0;
    
    
                if(this.verifica0670()) {
                    this.$refs['bv-modal-novo-pedido'].toggle('#btn-novo-pedido');
                } else {
                    await this.recuperaEndereco(this.dadosCartaoLocal.codExternoCartao, this.dadosCartaoLocal.digitoVerificador, this.dadosCartaoLocal.dependenteTitular.dependente.cpf)
                    if(this.isEnderecoExistente(this.dadosCartaoLocal)) {
    
                        this.$refs['bv-modal-novo-pedido'].toggle('#btn-novo-pedido');
    
                    } else {
    
                        var objParam = {
                            titulo: this.$t("label.aviso"),
                            descricao: this.$t("label.preencha_dados_para_emitir_boletos")
                        };
                        this.criaModalMensagem(objParam, null, null); 
                    }
                }
            },
  
            verifica0670() {
                var aux = ''
                var lenghtAux = ''
                var lenghtMax = ''
    
                aux = this.dadosCartaoLocal.codExternoCartao
    
                lenghtAux  = aux.length
                lenghtMax = aux.substring(0,4)		
    
                if (lenghtMax.includes('0670')) {
                    return true
                } else {
                    return false
                }
            },
  
            async abreModalDadosCadastrais() {
                this.$bvModal.show('modal-dados-cadastrais')
            },

            async abreModalCadastroEstudantil() {
                this.$bvModal.show('modal-cadastro-estudantil')
            },
  
            isEnderecoExistente(dadosCartaoLocal) {
                const { dependenteTitular } = dadosCartaoLocal;
                const { dependente } = dependenteTitular;
    
                const properties = ['nomeLogradouro', 'numero', 'cep', 'complemento', 'bairro'];
    
                for (const prop of properties) {
                    if (!dependente.hasOwnProperty(prop)) {
                    return false;
                    }
                }
                return true;
            },

            initializeValue() {
                if (!this.quantidade) {
                    this.quantidade = 1;
                }
                this.atualizaValorRecarga();
            },
  
            async recuperaEndereco(codigoCartao, digitoCartao, cpf) {
                var retorno = false;
    
                await this.cartaoService.getUserByCodCartao(codigoCartao, digitoCartao, cpf).then(
                    response => {	
                        this.dadosCartaoLocal = response
                        retorno = true;
                        return retorno
                    },
                    error => {
                        retorno = false
                        var objParam = {
                            titulo: this.$t("label.aviso"),
                            descricao: this.$t(error.response.data.detail)
					    };
					    this.criaModalMensagem(objParam, null, null); 
                        return retorno
                    }
                );
                return retorno;
            },
  
            async refreshListaPedidos() {
                this.spinnerQrcode = true;
                await this.getListaPedidos(this.dadosCartaoLocal.codExternoCartao);
                this.populaListaPedidosLocal();
                this.$refs.table.refresh();	
                this.spinnerQrcode = false;
            },
  
            async getListaPedidos(codigoCartao) {
                var retorno = false;
                this.spinnerQrcode = true;
                await this.cartaoService.getListaPedidos(codigoCartao).then(
                    response => {	
                        retorno = true;
                        this.updateStateListaPedidos(response);
                    }, error => { 
						var objParam = {
                            titulo: this.$t("label.aviso"),
                            descricao: this.$t(error.response.data.detail)
					    };
					    this.criaModalMensagem(objParam, null, null); 
                    }
                );
                this.spinnerQrcode = false;
    
                return retorno;			
            },
           
            editaBase64(arquivoBase64) {
                this.image.base64 = arquivoBase64.substring(23);
                return this.image.base64;
            },

            isDimensaoValida(largura, altura) {
                if(largura != 159 && altura != 129) {
                    throw new Error("label.dimensao_maxima");
                }
            },
  
            async consultarMetodoCompra(codigoCartao) {
                var retorno = false;
                this.valorRecarga = 0;
                this.valorRecargaLimit = 0;
                await this.cartaoService.consultarMetodoCompra(codigoCartao).then(
                    response => {	
                        this.porTarifa = response.conteudo.porTarifa;
                        
                        if (this.porTarifa) {			
                            response.conteudo.valoresVenda.forEach(element => { this.options.push( { value: element.valorVenda, text: element.codigoTarifaCliente + ' - R$ ' + element.valorVenda } ) });			
                            this.selected = response.conteudo.valoresVenda[0].valorVenda;
                        } else {
                            this.selected = 10;
                        }
                        retorno = true;
                    },
                    error => {
                        this.disabledNovoPedido = true;
                        retorno = false;		
						var objParam = {
                            titulo: this.$t("label.aviso"),
                            descricao: this.$t(error.response.data.detail)
					    };
					    this.criaModalMensagem(objParam, null, null);                        		
                    }
                );
                return retorno;			
            },
          
            async populaFormasDePagamento(codExternoCartao, praca) {
                var retorno = false;
                await this.cartaoService.consultarFormaPagamentoSite(codExternoCartao).then(
                    (response) => {
                        retorno = true;
                        this.montarDropDownFormaDePagamento(response, praca);
                    },
                    (error) => {
                        retorno = false;
                        var objParam = {
                            titulo: this.$t("label.aviso"),
                            descricao: this.$t(error.response.data.detail)
					    };
					    this.criaModalMensagem(objParam, null, null);
                    }
                );
                return retorno;
            },
  
            async montarDropDownFormaDePagamento(response, praça) {
                if (response.conteudo.permiteSelecionarPagto) {
                    if (praça.toLowerCase() === "the") {
                        const pixFormaPagamento = response.conteudo.formaPagamento.find(
                            (element) => element.descricaoPagamento === "PIX"
                        );
    
                        if (pixFormaPagamento) {
                            this.listaFormaDePagamento.push({
                            value: pixFormaPagamento.codigoPagamento,
                            text: pixFormaPagamento.descricaoPagamento,
                            });
    
                            this.setTokenPixLocalStorage(pixFormaPagamento);
                            this.selectedFormaDePagamento = pixFormaPagamento.codigoPagamento;
                            this.bloquearSelecionarPagto = true;
                        }
                    } 
                } 
    
                this.permiteSelecionarPagto = response.conteudo.permiteSelecionarPagto;
            },


            async aaa(response) {
			if (response.conteudo.permiteSelecionarPagto){
				response.conteudo.formaPagamento.forEach(element => {
					this.listaFormaDePagamento.push({ value: element.codigoPagamento, text: element.descricaoPagamento })
					this.setTokenPixLocalStorage(element)
					this.selectedFormaDePagamento = response.conteudo.formaPagamento[0].codigoPagamento;
					this.bloquearSelecionarPagto = response.conteudo.formaPagamento.length == 1 ? true : false;
				});			
			}
			
			this.permiteSelecionarPagto = response.conteudo.permiteSelecionarPagto;
		},

  
  
            async setTokenPixLocalStorage(element) { 
                if (element.codigoPagamento == 14) {
                    localStorage.setItem( 'tokenPix', JSON.stringify(element.tokenAutenticacaoPix));
                    localStorage.setItem( 'flowid', JSON.stringify(element.flowid));
                    localStorage.setItem( 'tenant', JSON.stringify(element.tenant));
                    localStorage.setItem( 'contextoPix', JSON.stringify(element.contextoPix));
                    localStorage.setItem( 'taxaPixCarga', JSON.stringify(element.taxaPixCarga));
                    localStorage.setItem( 'taxaPixServico', JSON.stringify(element.taxaPixServico));
                    this.nomeTitular = element.nomeTitular;
                    this.cnpj = element.cnpj;
                    this.contaCorrente = element.contaCorrente;
                    this.agencia = element.agencia;
                }
            },
  
  
            async getListaMunicipio() {
                var retorno = false;
                await this.municipioService.getListaMunicipio().then(
                    response => {	
                        retorno = true;
                        this.updateStateListaMunicipio(response);
                    }, error => { retorno = false; }
                );
                return retorno;			
            },
  
            async getListaLogradouro() {
                var retorno = false;
                await this.logradouroService.getListaLogradouro().then(
                    response => {
                        retorno = true;
                        this.updateStateListaLogradouro(response);
                    }, error => { retorno = false; }
                );
                return retorno;			
            },
          
            modalSalvo() {
                this.flagValidouOK = false;	
                this.criaModalMensagem({ titulo: this.$t("label.aviso"), descricao: this.$t("label.dados_salvo") }, null, null);   
            },

            modalSalvoDocumentos() {
                this.flagValidouOK = false;	
                this.criaModalMensagem({ titulo: this.$t("label.aviso"), descricao: this.$t("label.documentos_enviados") }, null, null);   
            },
          
            modalPedidoSalvo() {
                this.flagValidouOK = false;	
                this.criaModalMensagem({ titulo: this.$t("label.aviso"), descricao: this.$t("label.pedido_criado") }, null, null);   
            },
  
            async validaSalvar() {
                let informacoesDadosCadastrais = 
                    new DadosCadastraisModel(
                        this.dadosCartaoLocal.dependenteTitular.dependente.nomeLogradouro, 
                        this.dadosCartaoLocal.dependenteTitular.dependente.tipoLogradouro.id,
                        this.dadosCartaoLocal.dependenteTitular.dependente.complemento,
                        this.dadosCartaoLocal.dependenteTitular.dependente.numero,
                        this.dadosCartaoLocal.dependenteTitular.dependente.bairro,
                        this.dadosCartaoLocal.dependenteTitular.dependente.cep,
                        this.dadosCartaoLocal.dependenteTitular.dependente.email,
                    );
                try {
                    this.dadosCadastraisValidator.IsLogradouro(informacoesDadosCadastrais.nomeLogradouro)
                    this.dadosCadastraisValidator.IsTipoLogradouro(informacoesDadosCadastrais.tipoLogradouro)
                    this.dadosCadastraisValidator.IsComplemento(informacoesDadosCadastrais.complemento)
                    this.dadosCadastraisValidator.IsNumero(informacoesDadosCadastrais.numero)
                    this.dadosCadastraisValidator.IsBairro(informacoesDadosCadastrais.bairro)
                    this.dadosCadastraisValidator.IsCep(informacoesDadosCadastrais.cep)
                    this.dadosCadastraisValidator.IsEmail(informacoesDadosCadastrais.email)
    
                    await this.salvar()
                    this.modalSalvo()
    
                } catch (error) {
                    this.flagValidouOK = false;	
                    this.criaModalMensagem({ titulo: this.$t("label.aviso"), descricao: this.$t(error.message) }, null, null);   
                }
            },

            sleep(ms) {
                return new Promise(resolve => setTimeout(resolve, ms));
            },

            async salvarDocumentos(jsons) {
                await this.estudanteService.putDocumento(jsons).then(
                    response => {
                    }, error => { 
                    }
                );
            },

  
            onModalClose() {
                this.refreshListaPedidos()
            },

            async verificaDocumentos() {
            },
  
            async confirmaPedidoRecarga() {
                this.botaoDesabilitado = true

                let taxaPixCarga = JSON.parse(localStorage.getItem('taxaPixCarga') );
                let taxaPixServico = JSON.parse(localStorage.getItem('taxaPixServico') );
    
                var retorno = true;
                var codigoPedido = "";
                let registrarTXID;
                var dadosCartaoLocal = this.dadosCartaoLocal;
                var valorTotal = 0

                valorTotal = (parseFloat(this.valorModalFormatado.replace('R$', '').replace(',', '.')));

                var pedido = await this.criarPedido(dadosCartaoLocal, valorTotal, this.selectedFormaDePagamento);
                var txID = await this.gerarTxId(this.selectedFormaDePagamento);
                
                try{
                    await this.cartaoService.novoPedidoWeb(pedido).then(
                        response => {
                            codigoPedido = this.tratarResponseNovoPedidoWeb(response);
                        }, error => { 
                            var objParam = {
                                titulo: this.$t("label.aviso"),
                                descricao: this.$t(error.response.data.detail)
					        };
                            this.criaModalMensagem(objParam, null, null); 
                        }
                    );
                    
                    if (this.selectedFormaDePagamento == 14 && codigoPedido != '') { 
                        registrarTXID = await this.criarPedidoTXID(txID, this.dadosCartaoLocal.codExternoCartao, codigoPedido);
    
                        await this.cartaoService.registrarTxIdPedido(registrarTXID).then(
                            response => { }, error => { retorno = false; 
                                throw new Error("erro.error_api_registrar_txid"); 
                            }
                        );
                    }
                }
                catch (error) {
                    this.criaModalMensagem({ titulo: this.$t("label.aviso"), descricao: this.$t(error.message) }, null, null);   
                }
                this.botaoDesabilitado = false; 
                await this.getListaPedidos(this.dadosCartaoLocal.codExternoCartao);
                this.populaListaPedidosLocal();
                this.$refs.table.refresh();	
                return retorno;			
                
            },

            async consultarQRCode(txId, pedido, valor){
                this.spinnerQrcode = true;
                await this.pixService.consultarQRCode(txId).then(
                    response => {
                        this.imgQRCode = response.imagem_base64;
                        this.pedidoQRCode = pedido
                        this.valorQRCode = valor;
                        this.emv =  response.emv
                        this.$bvModal.show('modal-QRCode');
                    }, error => { 
                        this.spinnerQrcode = false;
                        if(error.response.status == 204){
                            throw new Error("erro.error_api_consulta_qrcode_pedido_204");
                        } else if(error.response.status == 404){
                            throw new Error("erro.error_api_consulta_qrcode_pedido_404");
                        } else if(error.response.status == 503){
                            throw new Error("erro.error_api_consulta_qrcode_pedido_503");
                        } else {
                            throw new Error("erro.error_api_consulta_qrcode_pedido");
                        }
                    }
                );
                this.spinnerQrcode = false;
            },
  
            async consultarCobranca(txId){
                this.status = ''
                let retorno = false;
                await this.pixService.consultarCobranca(txId).then(
                    response => {
                        this.dataCriacao = response.calendario.criacao
                        this.expiracaoPix = response.calendario.expiracao
                        this.status = response.status
                        retorno = true;
                    }, error => { 
                        if(error.response.status == 204){
                            retorno = true;
                        } else if(error.response.status == 404){
                            retorno = false;
                        } else if(error.response.status == 503){
                            throw new Error("erro.error_api_consulta_pedido_503");
                        } else {
                            throw new Error("erro.error_api_consulta_pedido");
                        }
                    }
                );
                return retorno;
            },
  
            async criarCobrancaPix(valorTotal, codigoPedido, nomeTitular, cnpj, contaCorrente, agencia, txID){
                    let pedidoPixApiModel = this.criarPixApiModel(valorTotal, codigoPedido, nomeTitular, cnpj, contaCorrente, agencia);
                    await this.pixService.criarCobranca(txID, pedidoPixApiModel).then(
                        response => {
                            this.dataCriacao = response.calendario.criacao
                            this.expiracaoPix = response.calendario.expiracao
                            this.status = response.status
                        }, error => { 
                            if(error.response.status == 204 || 
                                error.response.status == 201 || 
                                error.response.status == 202){
                            } else {
                                throw new Error("erro.error_api_criar_cobranca_pix");
                            }
                        }
                    );
            },
  
            tratarResponseNovoPedidoWeb(response){
                let retorno = '';
                
                if(response.data != null && response.data.codigoRetorno == 500 && response.message == "ERRO") {
                    retorno = '';				
                    this.criaModalMensagem({ titulo: this.$t("label.aviso"), descricao: this.$t('label.cartao_nao_habilitado_para_carga')}, null, null);
                } else if (response.data != null && response.data.codigoRetorno == 500) {
                    retorno = '';				
                    this.criaModalMensagem({ titulo: this.$t("label.aviso"), descricao: this.$t(response.data.mensagemDeErro) }, null, null);
                } else if (response.data.dadosPedidoRecarga !=null && response.data.dadosPedidoRecarga.codigo == -1) {
                    retorno = '';				
                    this.criaModalMensagem({ titulo: this.$t("label.aviso"), descricao: this.$t(response.data.dadosPedidoRecarga.mensagemDeErro) }, null, null);
                } else {
                    retorno = response.data.dadosPedidoRecarga.codigo;
                    this.$bvModal.hide('bv-modal-certificacao');
                    this.$bvModal.hide('bv-modal-novo-pedido');
                    this.modalPedidoSalvo();		
                }
                return retorno;
            },
  
            async gerarTxId(formaDePagamento) {
                var retorno = "";
                if (formaDePagamento == 14) {
                    await this.cartaoService.gerarTxId(formaDePagamento).then(
                        response => {
                            retorno = response.conteudo.txId;
                        }, error => { 
                            retorno = ""; 
                        }
                    );
                    return retorno;
                } else {
                    return "";
                }
            },
  
            async criarPedidoTXID(txId, codigoExternoCartao, pedido) {
                return {
                    "txId" : txId,
                    "codigoExternoCartao" : codigoExternoCartao,
                    "pedido" : pedido
                }
            },
  
            criarPedido(dadosCartaoLocal, valorTotal, formaDePagamento) {           
                if (formaDePagamento != 14) {
                    formaDePagamento = 1
                }
    
                if (this.praca.toLowerCase() === "the") {
                    //atualmente THE aceita apenas pix, depois criar logica no banco para nao ficar marretado aqui
                    formaDePagamento = 14
                }
                
                return {
                    "id": {
                        "cartao": { 
                            "codExternoCartao": dadosCartaoLocal.codExternoCartao, 
                            "numeroCartaoComDigito": dadosCartaoLocal.codExternoCartao + dadosCartaoLocal.digitoVerificador 
                        },
                        "solicitacaoPedidoCarga": { 
                            "valorPedido": valorTotal,
                            "formaPagamento": {id: formaDePagamento},
                        }
                    }  
                }
            },
  
            criarPixApiModel(valor, pedido, nomeTitular, cnpj, contaCorrente, agencia) {
                    return { 
                        "calendario":{
                            "expiracao":3600
                        },
                        "devedor":{
                            "cpf":null,
                            "nome":nomeTitular,
                            "cnpj":cnpj
                        },
                        "valor":{
                            "original":  valor.toString(),
                            "modalidadeAlteracao":0
                        },
                        "solicitacaoPagador":`Pedido de carga - ${pedido}`,
                        "infoAdicionais":[
                            {
                                "valor":pedido,
                                "nome":"Pedido de carga"
                            },
                            {
                                "valor":agencia,
                                "nome":"agencia "
                            },
                            {
                                "valor":contaCorrente,
                                "nome":"conta "
                            }
                        ]
                    }
            },
  
            async salvar() {
                var retorno = false;
                var self = this;
    
                var dependente = this.criarDependenteSalvarModel(self.dadosCartaoLocal);
                
                await this.cartaoService.salvar(dependente).then(
                    response => {
                        retorno = true;
                    }, error => { 
                        retorno = false; 
                        var objParam = {
						titulo: this.$t("label.aviso"),
						descricao: this.$t(error.response.data.detail)
					};
					this.criaModalMensagem(objParam, null, null); 
                    }
                );
            },
  
            criarDependenteSalvarModel(dadosCartaoLocal) { 
                return {
                    "id" : dadosCartaoLocal.dependenteTitular.dependente.id,
                    "nomeLogradouro" : dadosCartaoLocal.dependenteTitular.dependente.nomeLogradouro,
                    "complemento" : dadosCartaoLocal.dependenteTitular.dependente.complemento,
                    "bairro" : dadosCartaoLocal.dependenteTitular.dependente.bairro,
                    "cep" : dadosCartaoLocal.dependenteTitular.dependente.cep.replace("-",""),
                    "email" : dadosCartaoLocal.dependenteTitular.dependente.email,
                    "telefone": dadosCartaoLocal.dependenteTitular.dependente.telefone.replace("-","").replace("(","").replace(")","").replace(" ",""),
                    "tipoLogradouro" : {
                        "id" : dadosCartaoLocal.dependenteTitular.dependente.tipoLogradouro.id
                        },
                    "municipio": {
                        "id" : dadosCartaoLocal.dependenteTitular.dependente.municipio.id
                        },
                    "numero" : dadosCartaoLocal.dependenteTitular.dependente.numero
                };
            },
  
            async imprimirPix(txId, pedido, valor) { 
                    valor = parseFloat(valor).toFixed(2);
                    this.spinnerQrcode = true;
                    var formaPagamento = 14
                    
                    try {
                        if(!await this.consultarCobranca(txId)){
                            await this.criarCobrancaPix(valor, pedido, this.nomeTitular, this.cnpj, this.contaCorrente, this.agencia, txId);
                        }
                        if(this.status != "CONCLUIDA") {
                            if(this.consultaExpiracaoPix() && this.status === "ATIVA") {
                            await this.consultarQRCode(txId, pedido, valor);
                            } else {
                                this.cancelaCobranca(txId)
                                this.novoTxId = await this.gerarTxId(formaPagamento);
                                await this.criarCobrancaPix(valor, pedido, this.nomeTitular, this.cnpj, this.contaCorrente, this.agencia, this.novoTxId);
                                this.registrarNovoTXID = await this.criarPedidoTXID(this.novoTxId, this.dadosCartaoLocal.codExternoCartao, pedido);
                                this.registrarNovoTxid(this.registrarNovoTXID)
                                await this.consultarQRCode(this.novoTxId, pedido, valor); //mostra o pix na tela
                                this.refreshListaPedidos()
                        }
                        }
                    } catch (error) {
                        this.criaModalMensagem({ titulo: this.$t("label.aviso"), descricao: this.$t(error.message) }, null, null);   
                    } finally {
                        this.spinnerQrcode = false;				
                    }      
            },
  
            async registrarNovoTxid(novoTXID) {
                await this.cartaoService.registrarTxIdPedido(novoTXID).then(
                    response => { }, error => { retorno = false; 
                        throw new Error("erro.error_api_registrar_txid"); 
                    }
                );
            },
  
            consultaExpiracaoPix() {           
                this.dataCriacao = this.formataDataPix()
                this.tempoDecorridoSegundos = this.comparaDataCriacaoComAtual(this.dataCriacao)
    
                if (this.comparaTempoDecorridoComExpiracao(this.tempoDecorridoSegundos, this.expiracaoPix)) {
                    return true
                } else{
                    return false
                }
            },
  
            formataDataPix() {          
                return this.dataCriacao.replace('T', ' ').replace('Z', '');
            },
  
            comparaDataCriacaoComAtual(dataCriacao) {
                let date = new Date(dataCriacao);
                let now = new Date();
                let tempoDecorrido = (now - date) / 1000;
                return tempoDecorrido     
            },
  
            comparaTempoDecorridoComExpiracao(tempoDecorrido, expiracao) {
                if(tempoDecorrido >= expiracao) {
                    return false
                } else {
                    return true
                }
            },
  
            async cancelaCobranca(txid) {
                var retorno = false
                let status = {
                    "status" : "REMOVIDA_PELO_USUARIO_RECEBEDOR",
                    "revisao": "1"
                }
                
                await this.pixService.cancelaCobranca(txid, status).then(
                    response => {
                        retorno = true;
                    }, error => { 
                    }
                );
            },
  
            async imprimirBoleto(codPedido) {
                this.spinnerBoleto = true;
                var retorno = false;
    
                var dadosCartaoLocal = this.dadosCartaoLocal;
                var cartaoSolicitacaoPedidoCarga = {

                    //"codigoPedido" : 387960,
                    //"codIdentificacaoExt": '036500000037808'
                    "codigoPedido" : codPedido,
                    "codIdentificacaoExt": dadosCartaoLocal.codExternoCartao
                }    
                
                try {
                    const response = await this.cartaoService.imprimirBoleto(cartaoSolicitacaoPedidoCarga);
                    if (response) {
                        var retorno = response.split(';');
                        var base64Response = retorno[1];
                        var nomeResponse = retorno[0];
                        this.metodosAuxiliares.baixarPdf(base64Response, nomeResponse)
                        retorno = true;
                    } else {
                        retorno = false;
                    }
                } catch (error) { 
                    var objParam = {
                        titulo: this.$t("label.aviso"),
                        descricao: this.$t(error.response.data.detail)
                    };
                    this.criaModalMensagem(objParam, null, null); 
                } finally {
                    this.spinnerBoleto = false;
                }
            },
  
            async imprimirRecibo(codPedido) {
                this.spinnerQrcode = true;
                
                var retorno = false;
                var dadosCartaoLocal = this.dadosCartaoLocal;
                var cartaoSolicitacaoPedidoCarga = {
                    "codigoPedido" : codPedido,
                    "codIdentificacaoExt": dadosCartaoLocal.codExternoCartao
                }
                
                await this.cartaoService.imprimirRecibo(cartaoSolicitacaoPedidoCarga).then(
                    response => {
                        if(response == undefined){
                            this.criaModalMensagem({ titulo: this.$t("label.aviso"), descricao: this.$t("label.servico_indisponivel") }, null, null);   
                        } else {
                            var base64Response = response.split(';')[1]
                            var nomeResponse = response.split(';')[0]
                            this.metodosAuxiliares.baixarPdf(base64Response, nomeResponse)
                            retorno = true;
                        }
                        
                    }, error => { 
                        retorno = false; 
                        var objParam = {
                            titulo: this.$t("label.aviso"),
                            descricao: this.$t(error.response.data.detail)
					    };
					    this.criaModalMensagem(objParam, null, null);
                    }
                );
                this.spinnerQrcode = false;
            }
        }
    };
</script>

  